import { FLOW_HEADER_HEIGHT_FALLBACK } from 'automation-ui-core/constants/ui';
import { useEffect, useState } from 'react';
export const getCanvasTopOffset = canvasScrollElementRef => {
  var _workflowsRoot$getBou, _workflowsRoot$getBou2, _canvasScrollElementR;
  const workflowsRoot = document.querySelector('[data-application-name="automation-ui-canvas"]');
  const workflowsRootRect = (_workflowsRoot$getBou = workflowsRoot === null || workflowsRoot === void 0 || (_workflowsRoot$getBou2 = workflowsRoot.getBoundingClientRect()) === null || _workflowsRoot$getBou2 === void 0 ? void 0 : _workflowsRoot$getBou2.top) !== null && _workflowsRoot$getBou !== void 0 ? _workflowsRoot$getBou : 0;
  const canvasRect = canvasScrollElementRef === null || canvasScrollElementRef === void 0 || (_canvasScrollElementR = canvasScrollElementRef.current) === null || _canvasScrollElementR === void 0 ? void 0 : _canvasScrollElementR.getBoundingClientRect();
  return canvasRect ? canvasRect.top - workflowsRootRect : FLOW_HEADER_HEIGHT_FALLBACK;
};
export const useCanvasTopOffset = canvasScrollElementRef => {
  const [canvasTopOffset, setCanvasTopOffset] = useState(getCanvasTopOffset(canvasScrollElementRef) || FLOW_HEADER_HEIGHT_FALLBACK);
  useEffect(() => {
    if (!(canvasScrollElementRef !== null && canvasScrollElementRef !== void 0 && canvasScrollElementRef.current)) return;
    const resizeObserver = new ResizeObserver(() => {
      setCanvasTopOffset(getCanvasTopOffset(canvasScrollElementRef));
    });
    resizeObserver.observe(canvasScrollElementRef.current);
    return () => {
      resizeObserver.disconnect();
    };
  }, [canvasScrollElementRef]);
  return canvasTopOffset;
};